import { render } from "./ContactRequestType.vue?vue&type=template&id=3b56721c&scoped=true"
import script from "./ContactRequestType.vue?vue&type=script&lang=js"
export * from "./ContactRequestType.vue?vue&type=script&lang=js"

import "./ContactRequestType.vue?vue&type=style&index=0&id=3b56721c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b56721c"]])

export default __exports__